import React, { useState } from "react";
import "./SubscriptionComponent.scss"
import { isValidPhoneNumber } from 'react-phone-number-input';
import Button from "../Button/Button";
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
import VirasatInputComponents from "../VirasatInputComponents/VirasatInputComponents";
import PhoneInputComponent from "../VirasatInputComponents/PhoneInputComponent";

const SubscriptionComponent = () => {
    const companyDetails = useSelector((state) => state.companyData.company)
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [errors, setErrors] = useState({
        name: "",
        email: "",
        phone: ""
    })

    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;

        const newErrors = {
            name: "",
            email: "",
            phone: ""
        };

        const trimmedName = name.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        if (trimmedName === "") {
            newErrors.name = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.name = "Please enter a valid name";
            valid = false;
        }


        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }


        if (trimmedPhone === "") {
            newErrors.phone = "*Required";
            valid = false;
        } else if (!isValidPhoneNumber(trimmedPhone)) {
            newErrors.phone = "Please enter a valid phone number";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.ID || "",
            "Name": name,
            "Email": email,
            "PhoneNo": phoneNumber,
            "Message": "",
            "Subject": "Shop Opening",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setName("")
                setPhoneNumber("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    return (
        <div className="SubscriptionComponent-Virasat">
            <div className="SubscriptionComponent-Virasat-inner">
                <div className="SubscriptionComponent-Virasat-inner-title">Stay
                    <div className="SubscriptionComponent-Virasat-inner-title-hl">Tuned!</div></div>
                <div className="SubscriptionComponent-Virasat-inner-subheader">Want to be the first to know when our shop opens? Just hit subscribe and we’ll notify you the moment we're open for business!</div>
                <div className="SubscriptionComponent-Virasat-inner-form">
                    <VirasatInputComponents label={"Name"}
                        placeholder={"Enter your full name"}
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value)
                            handleChange("name")
                        }}
                        required
                        error={errors.name !== ""}
                        errorText={errors.name}
                    />
                    <VirasatInputComponents label={"Email"}
                        placeholder={"Enter your email address"}
                        onChange={(e) => {
                            setEmail(e.target.value)
                            handleChange("email")

                        }}
                        value={email}
                        required
                        error={errors.email !== ""}
                        errorText={errors.email}
                    />
                    <PhoneInputComponent label={"Phone Number"}
                        placeholder={"Enter your phone number"}
                        onChange={(e) => {
                            if (e === undefined) {
                                setPhoneNumber("")
                            } else {
                                setPhoneNumber(e)
                            }
                            handleChange("phone")

                        }}
                        value={phoneNumber}
                        required
                        error={errors.phone !== ""}
                        errorText={errors.phone}
                    />
                    {showSuccess && < div className="succes-alert">
                        ✔ Thanks for subscribing! We can’t wait to open our doors to you..
                    </div>}
                    <div className="SubscriptionComponent-Virasat-inner-form-btn-cont">
                        <Button text={"SUBSCRIBE"} width={"200px"} isloading={loading} onClick={handleContact} />

                    </div>
                </div>
            </div>
        </div >
    )
}
export default SubscriptionComponent 